import { CheckCircle2, AlertTriangle, AlertOctagon, HelpCircle } from "lucide-react";

const MAP = {
  neutre: {
    label: "À renseigner",
    icon: HelpCircle,
    cls: "text-slate-600 bg-slate-100 border-slate-200",
  },
  vert: {
    label: "Entretien OK",
    icon: CheckCircle2,
    cls: "text-emerald-700 bg-emerald-50 border-emerald-200",
  },
  orange: {
    label: "Entretien à prévoir",
    icon: AlertTriangle,
    cls: "text-amber-700 bg-amber-50 border-amber-200",
  },
  rouge: {
    label: "En retard",
    icon: AlertOctagon,
    cls: "text-red-700 bg-red-50 border-red-200",
  },
};

export const StatusBadge = ({ status = "neutre", label, testId }) => {
  const s = MAP[status] || MAP.neutre;
  const Icon = s.icon;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border ${s.cls}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {label || s.label}
    </span>
  );
};
